import UtpAdsDataStore from '@/data/datastores/UtpAdsDataStore';

export default class UtpAdsDataStoreMock implements UtpAdsDataStore {
  async getUtpAdsData(): Promise<any> {
    const data = {
      ads: {
        advertisement: {
          idCampaing: 1,
          name: 'Campaña actualización celulares',
          title: '¡Actualiza tu teléfono y gana!',
          message:
            'Sortearemos 1 laptop, 1 tablet y 1 celular. Participa hasta el 30 de mayo de 2025.',
          termsLink:
            'https://drive.google.com/file/d/19urgkZ9nI99nEowrQ5meE1ap8bjUEgOz/view',
          dateStart: '2025-05-02T00:00:00.000Z',
          dateEnd: '2025-06-02T00:00:00.000Z',
          isInternal: true,
          target: '/perfil/informacion-personal'
        }
      }
    };
    return { utpAds: data.ads.advertisement };
  }
}
